/** Constants used by dnd-kit droppable/draggable hooks to identify what's being dragged and dropped where. */
export const CONDITION_TYPE = "condition";
export const EFFECT_TYPE = "effect";
export const EFFECT_SORTABLE_ZONE = "effectSortableZone";
export const EFFECT_DROPPABLE_ZONE = "effectDroppableZone";

export const TYPE_BUILDABLE = "buildable";
export const TYPE_INSTANCE = "instance";
export const TYPE_DROPPABLE = "droppable";
export const TYPE_ROOT_DROPPABLE = "rootDroppable";
export const TYPE_CANCEL = "cancel";

/** The names of the special "utility" condition builders for all nodes. Automatically added by the system. */
export const GROUP_CONDITION_NAME = "@@group";
export const NEGATION_CONDITION_NAME = "@@negation";

/* The key used to access child conditions of a group condition node.
 * eg: groupCondition: {
 *   children: {
 *    values: [condition1, condition2, ...]
 *   }
 * }
 */
export const GROUP_CONDITION_CHILDREN_KEY = "values";
